module.exports = __webpack_public_path__ + "static/media/account-feature-services.0bbfc658.png";